export { store, createAppStore } from './store';
export type { RootState, AppDispatch, AdditionalApiConfig } from './store';
export { StoreProvider } from './provider';

// Notification types
export type {
  NotificationPriority,
  NotificationType,
  NotificationPosition,
  NotificationAction,
  Notification,
  NotificationInput,
  NotificationSettings,
  NotificationState,
} from './types/notification.types';

// Notification slice
export {
  addNotification,
  removeNotification,
  clearNotifications,
  updateNotificationSettings,
  selectNotifications,
  selectVisibleNotifications,
  selectNotificationSettings,
} from './slices/notificationSlice';
export { default as notificationReducer } from './slices/notificationSlice';

// Notification hook
export { useNotification } from './hooks/useNotification';
export type { UseNotificationReturn } from './hooks/useNotification';

// Notification message constants
export * from './constants/notificationMessages';

// RTK Query error middleware
export { rtkQueryErrorMiddleware } from './middleware/notificationMiddleware';

// Pluggable handler for unauthorized (401) responses. The web app registers a
// handler that sanitizes an invalidated session; unregistered consumers no-op.
export { setUnauthorizedHandler, getUnauthorizedHandler } from './middleware/unauthorizedHandler';
export type { UnauthorizedHandler, UnauthorizedContext } from './middleware/unauthorizedHandler';

// Map types
export type { MarkerData, MapState } from './types/map.types';

// Map slice
export {
  setMarkers,
  clearMap,
  setSelectedPlace,
  selectMarkers,
  selectSelectedPlaceId,
} from './slices/mapSlice';
export { default as mapReducer } from './slices/mapSlice';

// Preference slice (FRE-774) — taste preferences for /for-you
export type { PreferenceState } from './slices/preferenceSlice';
export {
  setPreferences,
  resetPreferences,
  selectTastePreferences,
  DEFAULT_TASTE_PREFERENCES,
} from './slices/preferenceSlice';
export { default as preferenceReducer } from './slices/preferenceSlice';

// Recent events slice (FRE-767)
export type { RecentEvent, RecentEventsState } from './slices/recentEventsSlice';
export {
  addRecentEvent,
  clearRecentEvents,
  selectRecentEvents,
  hydrateRecentEventsFromStorage,
  RECENT_EVENTS_STORAGE_KEY,
  RECENT_EVENTS_MAX,
} from './slices/recentEventsSlice';
export { default as recentEventsReducer } from './slices/recentEventsSlice';

// Map tool interceptor types
export type {
  DisplayPlaceOnMapToolInput,
  DisplayPlaceOnMapToolPart,
  DisplayPlaceOnMapToolPartState,
  MessageLike,
  AddToolOutputArgs,
  AddToolOutputFn,
  UseMapToolInterceptorReturn,
} from './types/mapTool.types';
export {
  DISPLAY_PLACE_ON_MAP_TOOL_PART_TYPE,
  DISPLAY_PLACE_ON_MAP_TOOL_NAME,
} from './types/mapTool.types';

// Map tool interceptor hook
export { useMapToolInterceptor } from './hooks/useMapToolInterceptor';
